module.exports = __webpack_public_path__ + "img/Button_AppStoreEnabled.1ea93dd4.png";